/*
Sohel 01/31/2023 2698951347 label changes
Sohel 01/08/2023 2701335619 implemented Usage Functionality
Akhila 06/08/2023 2701335619 title label placeholder name change
Akhila 06/12/2023 2701335619 added role access
Phanee 08/03/2023 2701335619 Fixed dashboard data disable issue
*/
import React, {useState, useContext} from 'react';
import LandingPage from '../../../LandingPage';
import SearchExportMRGroup from './SearchExportMRGroup';
import AddExportMRGroup from '../ImportManagerRecordGroup/AddImportMRGroup';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import DataManagerRecordGroupUsage from '../ImportManagerRecordGroup/DataManagerRecordGroupUsage';
import {EXPORT_DATA} from '../../../../constants/ReusableRoleAccess';
import {useSelector} from 'react-redux';

function ImportManagerRecordGroup() {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [value, setValue] = useState(0);
  const [dataManagerRecordGroupData, setDataManagerRecordGroupData] = useState({});
  const [editExisting, setEditExisting] = useState(false);
  const {roleData} = useSelector(({role}) => role);
  const exportRecordGroupAccess = roleData?.window?.[EXPORT_DATA]?.['ERG'];

  const tabLabels = ['Export Record Groups'];
  return (
    <>
      <LandingPage
        title={'Data Management'}
        showTabs={true}
        tabValue={0}
        handleTabChange={()=>{}}
        allAntTabs={tabLabels}
      >
        <div className="global-field-dash-board">
          <div className={` ${classes.cardStyleWhite}`}>
            <div className={classes.root}>
              <div className={classes.subContent}>
                {value === 0 && (
                  <SearchExportMRGroup
                    exportRecordGroupAccess={exportRecordGroupAccess}
                    setEditExisting={setEditExisting}
                    setValue={setValue}
                    setDataManagerRecordGroupData={setDataManagerRecordGroupData}
                  />
                )}
                {value === 1 && (
                  <AddExportMRGroup
                    exportRecordGroupAccess={exportRecordGroupAccess}
                    editExisting={editExisting}
                    setValue={setValue}
                    exportManagerRecordGroup={true}
                  />
                )}
                {value === 2 && (
                  <DataManagerRecordGroupUsage
                    setValue={setValue}
                    dataManagerRecordGroupData={dataManagerRecordGroupData}
                    exportManagerRecordGroup={true}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </LandingPage>
    </>
  );
}

export default ImportManagerRecordGroup;
